import React from 'react';
export const AddCharger = React.lazy(() => import('./AddCharger'));